/**
 * Catalogue des pictogrammes de VUE — tracés SVG CONSTANTS, indexés par clé.
 *
 * Une vue ne stocke en base que la CLÉ (`vues.icone`). Le tracé est injecté
 * par `v-html` dans la barre latérale : il ne doit donc JAMAIS venir de la base
 * ni de l'API, sinon un administrateur malveillant (ou un compte compromis)
 * injecterait du HTML dans l'écran de tous ses collègues. Ici, tout tracé est
 * une constante relue dans ce fichier.
 *
 * Une clé inconnue (vue créée par une version plus récente, faute de frappe
 * via l'API) retombe sur `tableau` : un pictogramme générique vaut mieux qu'un
 * trou dans le menu.
 */
export const ICONES_VUE: Readonly<Record<string, string>> = {
  tableau:
    '<rect x="3" y="4" width="18" height="16" rx="2" /><line x1="3" y1="10" x2="21" y2="10" /><line x1="9" y1="10" x2="9" y2="20" />',
  boite:
    '<path d="M20 7 12 3 4 7v10l8 4 8-4z" /><path d="M4 7l8 4 8-4" /><line x1="12" y1="11" x2="12" y2="21" />',
  personnes:
    '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />',
  personne: '<circle cx="12" cy="8" r="4" /><path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1" />',
  maison: '<path d="M3 11 12 3l9 8" /><path d="M5 10v10h14V10" /><path d="M10 20v-6h4v6" />',
  soleil:
    '<circle cx="12" cy="12" r="4" /><line x1="12" y1="2" x2="12" y2="4" /><line x1="12" y1="20" x2="12" y2="22" /><line x1="2" y1="12" x2="4" y2="12" /><line x1="20" y1="12" x2="22" y2="12" /><line x1="4.9" y1="4.9" x2="6.3" y2="6.3" /><line x1="17.7" y1="17.7" x2="19.1" y2="19.1" /><line x1="4.9" y1="19.1" x2="6.3" y2="17.7" /><line x1="17.7" y1="6.3" x2="19.1" y2="4.9" />',
  eclair: '<path d="M13 2 3 14h9l-1 8 10-12h-9z" />',
  thermometre: '<path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z" />',
  outil:
    '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94z" />',
  camion:
    '<rect x="1" y="6" width="14" height="10" rx="1" /><path d="M15 9h4l3 3v4h-7" /><circle cx="6" cy="18" r="2" /><circle cx="18" cy="18" r="2" />',
  document:
    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /><line x1="8" y1="13" x2="16" y2="13" /><line x1="8" y1="17" x2="14" y2="17" />',
  dossier: '<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />',
  calendrier:
    '<rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />',
  telephone:
    '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />',
  euro: '<path d="M18 7a7 7 0 1 0 0 10" /><line x1="4" y1="10" x2="14" y2="10" /><line x1="4" y1="14" x2="14" y2="14" />',
  graphique:
    '<line x1="4" y1="20" x2="20" y2="20" /><rect x="6" y="11" width="3" height="7" /><rect x="11" y="7" width="3" height="11" /><rect x="16" y="13" width="3" height="5" />',
  etoile: '<path d="m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z" />',
  etiquette:
    '<path d="M20.59 13.41 11 3H4v7l9.59 9.59a2 2 0 0 0 2.82 0l4.18-4.18a2 2 0 0 0 0-2.82z" /><circle cx="7.5" cy="7.5" r="1.5" />',
  carte:
    '<path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2z" /><line x1="9" y1="4" x2="9" y2="18" /><line x1="15" y1="6" x2="15" y2="20" />',
  liste:
    '<line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><circle cx="4" cy="6" r="1" /><circle cx="4" cy="12" r="1" /><circle cx="4" cy="18" r="1" />',
}

export const ICONE_PAR_DEFAUT = 'tableau'

/** Tracé d'une clé, avec repli. Toujours une constante de ce fichier. */
export function iconeVue(cle: string): string {
  // Propriété PROPRE seulement : la clé « constructor » respecte le format côté
  // serveur, et `ICONES_VUE[cle]` aurait rendu la fonction `Object` héritée —
  // injectée telle quelle dans le SVG.
  return Object.prototype.hasOwnProperty.call(ICONES_VUE, cle)
    ? (ICONES_VUE[cle] as string)
    : (ICONES_VUE[ICONE_PAR_DEFAUT] as string)
}
